type Phone = {
  primary?: boolean | null;
};

type Customer = {
  phones?: Phone[] | null;
};

type Account<T extends Customer> = {
  customers?: T[] | null;
};

export const getPrimaryCustomer = <T extends Customer>(account: Account<T>): T | undefined => {
  return account.customers?.find((customer) => customer.phones?.some((phone) => phone.primary));
};
